import { Routes } from '@angular/router';
import { LoginPageComponent } from './shared/pages/login-page/login-page.component';

export const ROUTES: Routes = [
	{ path: '', redirectTo: 'client', pathMatch: 'full' },
	{
		path: 'client',
		loadChildren: () => import('./client/client.module').then(m => m.ClientModule),
	},
	{ path: 'login', component: LoginPageComponent },
];
